module.exports = __webpack_public_path__ + "static/img/sm_banner.e963717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/sm_banner.png
// module id = Qukh
// module chunks = 1